// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"CircleLoading_loadingWrapper__Kf73H","spin":"CircleLoading_spin__cI3SO"};